import repository from '@/api/repository';

export default {
  login(username: string, password: string) {
    return repository.post('auth/login', { username, password });
  },
};
